import { Report, ReportTemplate, ReportType, TabularConfiguration } from "../../../shared/reporting/api/biClient.types";
import { createTabularDefaultSettings } from "../../../shared/reporting/utils/isConfigurationValid";

export function getNewReport(clientCode: string): Report {
  return {
    ...getDefaultReportData(clientCode, "New Report"),
    reportType: ReportType.Tabular,
  } as Report;
}

export function getNewReportTemplate(dataSource: string, organization: string): ReportTemplate {
  return {
    ...getDefaultReportData(dataSource, "New Template"),
    status: "Draft",
    organization: organization,
    fundTypes: [],
    dataSource: dataSource,
    description: "",
  } as ReportTemplate;
}

function getDefaultReportData(clientCode: string, name: string): Report {
  return {
    name: name,
    clientCode: clientCode,
    configuration: {
      conditions: [],
      fields: [],
      sort: [],
      grouping: [],
      settings: createTabularDefaultSettings(),
    } as TabularConfiguration,
    reportType: ReportType.Tabular,
  } as Report;
}
